import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useApiClientProject } from '~/@api/client/useApiClientProject'

function useProjectMedium(projectId: string, filePath: string) {
  const client = useApiClientProject()

  const filename = useMemo(() => filePath.split('/').pop() ?? '', [filePath])

  return useQuery({
    queryKey: ['project-medium', projectId, filename],
    queryFn: () =>
      client.project
        .projectControllerDownloadProjectMedium(projectId, filename)
        .then((resp) => resp.data),
  })
}

export { useProjectMedium }
